"use strict";

PF.Field.DateDiapason = class DateDiapason extends PF.Field.String
	{
	static get options()
		{
		return {
			minDate: undefined,
			maxDate: undefined,
			html: PF.Field.DateDiapason.templates,
			tooltipConfig: {
				shift: [
					[20, 0],
					[20, 16],
					[-12, 0],
					[-12, 0]
				]
			},
			bottomPanelConfig: {
				steps: [
					'0px', '380px'
				],
			},
			startKey: 'start',
			finishKey: 'finish',
			label: 'Выберите диапазон дат',
			calendarConfig: {
				dayClass: PF.Field.DateDiapason.Day
			},
			errors: {
				incorrectValue: 'Некорректное значение'
			}
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			calendarContainerTooltip: `
			 <div class="pf-date-tooltip-calendar"></div>
			`,
			//language=HTML
			containerBottom: `
			 <div>
				 <div class="container-bottom">
					 <div class="container-bottom-title">Выберите дату:</div>
					 <div class="container-bottom-group">
						 <button pf="containerBottomCopy" class="button-date button button-fill button-round color-gray" title="Копировать"><i class="material-icons">content_copy</i></button>
						 <button pf="containerBottomPaste" class="button-date button button-fill button-round color-blue" title="Вставить"><i class="material-icons">content_paste</i></button>
						 <button pf="containerBottomClear" class="button-date button button-fill button-round color-yellow" title="Очистить"><i class="material-icons">backspace</i></button>
						 <button pf="containerBottomClose" class="button-date button button-fill button-round color-red" title="Отмена"><i class="material-icons">clear</i></button>
					 </div>
				 </div>
				 <div pf="calendarContainerBottom"></div>
			 </div>
			`,
		};
		}

	init()
		{
		super.init();
		this.diapason = {start: null, finish: null};
		this.highlightedDays = [];

		if (PF.H.isBigScreen())
			{
			this.dom.calendarContainer = this.dom.calendarContainerTooltip;
			this.popup = new PF.Popup.Tooltip({
				dom: {
					content: this.dom.calendarContainerTooltip,
					anchor: this.dom.wrapper,
				},
				...this.tooltipConfig,
			});
			this.popup.dom.popup.addClass('pf-date-tooltip');

			this.dom.input.onValue('focus', true, () => {
				this.popup.open();
				this.popup.once('opened', () => this.dom.input.focus = true);
			});
			}
		else
			{
			this.dom.calendarContainer = this.dom.calendarContainerBottom;
			this.popup = new PF.BottomPanel({
				dom: {
					container: app.dom.app,
					content: this.dom.containerBottom,
					// touch: this.list.dom.header,
				},
				...this.bottomPanelConfig
			});
			this.dom.input.node.setAttribute('readonly', 'readonly');
			this.dom.input.on('click', () => {
				this.popup.open();
				this.popup.once('opened', () => {
					this.dom.input.focus = true;
					this.inputOldValue = this.dom.input.value; // записать старое значение при открытии
				});
			});

			//------------------------------
			// отправить в clipboard
			this.dom.containerBottomCopy.on('click', () => {
				let inputValue = this.dom.input.value;
				if (inputValue)
					{
					navigator.clipboard.writeText(inputValue)
						.then(() => {
							// console.log('Secess');
						})
						.catch(err => {
							console.log('Something went wrong', err);
						});
					}
			});
			// вставить из clipboard
			this.dom.containerBottomPaste.on('click', () => {
				navigator.clipboard.readText()
					.then(text => {
						// console.log(text);
						let realValue = this.calcRealValue(text);
						this.model.setData(this.startKey, realValue.start);
						this.model.setData(this.finishKey, realValue.finish);
					})
					.catch(err => {
						console.log('Something went wrong', err);
					});
			});
			// закрыть
			this.dom.containerBottomClose.on('click', () => {
				let realValue = this.calcRealValue(this.inputOldValue);
				if (realValue !== undefined)
					{
					this.model.setData(this.startKey, realValue.start);
					this.model.setData(this.finishKey, realValue.finish);
					}
				this.popup.close();
			});
			// очистить
			this.dom.containerBottomClear.on('click', () => {
				this.inputOldValue = null;
				this.model.setData(this.startKey, null);
				this.model.setData(this.finishKey, null);
			});
			//------------------------------
			}


		this.model.onChange(this.key, () => {
			this.setSelected(this.calendar.findDay(this.model.get(this.key)));
		});

		this.onChange(["model." + this.startKey, "model." + this.finishKey], () => {
			this.diapason = {
				start: Util.fromDbDate(this.model.get(this.startKey), null),
				finish: Util.fromDbDate(this.model.get(this.finishKey), null)
			};
			this.calcInputStatus();
		}, true);


		this.calendar = new PF.Calendar({
			dom: {
				element: this.dom.calendarContainer,
			},
			field: this,
			...this.calendarConfig,
		});


		this.popup.on('opened', () => {
			if (this.inputStatus !== "nothing")
				{
				this.calendar.rebuild(this.diapason.start);
				}
			else
				{
				this.calendar.rebuild(DateTime.local());
				}
			// this.trigger('highlightSelected');
		});

		this.calc('showInfo', ['error', 'popup.state'], (e, s) => {
			return (s !== 'open' && s !== 'opening') || ((s === 'open' || s === 'opening') && e !== '');
		});

		// this.dom.input.onValue('focus', false, () => this.popup.close());


		this.onChange('inputStatus', () => this.highlightSelected());

		}

	highlightSelected()
		{
		for (let i = 0; i < this.highlightedDays.length; i++)
			{
			this.highlightedDays[i].selected = false;
			}
		this.highlightedDays = [];

		if (this.inputStatus === "startSelected")
			{
			let day = this.calendar.findDay(this.diapason.start);
			if (day !== undefined)
				{
				day.selected = true;
				this.highlightedDays.push(day);
				}
			}
		else if (this.inputStatus === "bothSelected")
			{
			for (let date = this.diapason.start; date <= this.diapason.finish; date = date.plus({days: 1}))
				{
				let day = this.calendar.findDay(date);
				if (day === undefined)
					{
					break;
					}
				day.selected = true;
				this.highlightedDays.push(day);
				}
			}
		}


	calcInputStatus()
		{
		if (this.diapason.start === null)
			{
			this.inputStatus = "nothing";
			}
		else if (this.diapason.finish === null)
			{
			this.inputStatus = "startSelected";
			}
		else
			{
			this.inputStatus = "bothSelected";
			}
		}

	setSelected(day)
		{
		this.pauseEvent('highlightSelected');
		let prevStatus = this.inputStatus;
		if (this.inputStatus === "bothSelected" || this.inputStatus === "nothing")
			{
			this.model.setData(this.startKey, Util.toDbDate(day.model.day), true);
			this.model.setData(this.finishKey, null, true);
			}
		else
			{
			let luxonStart = Util.fromDbDate(this.model.get(this.startKey));
			let luxonFinish = day.model.day;
			if (luxonStart > luxonFinish)
				{
				this.model.setData(this.startKey, Util.toDbDate(luxonFinish), true);
				this.model.setData(this.finishKey, Util.toDbDate(luxonStart), true);
				this.model.trigger('changed');
				}
			else
				{
				this.model.setData(this.startKey, Util.toDbDate(luxonStart), true);
				this.model.setData(this.finishKey, Util.toDbDate(luxonFinish), true);
				this.model.trigger('changed');
				}
			}
		console.log(this.diapason);
		this.highlightSelected();
		this.resumeEvent('highlightSelected');
		}

	bindInput()
		{
		// this.onChange(["model." + this.startKey, "model." + this.finishKey], () => {
		// 	this.dom.input.value = this.calcDisplayValue(this.model.get(this.startKey, null, null), this.model.get(this.finishKey, null, null));
		// 	this.validate(true);
		// }, true);
		this.onChange('diapason', () => {
			this.pauseEvent('dom.input.change:value@dateDiapason');
			this.dom.input.value = this.calcDisplayValue(this.model.get(this.startKey, null, null), this.model.get(this.finishKey, null, null));
			this.validate(true);
			this.resumeEvent('dom.input.change:value@dateDiapason');
		});
		this.on('dom.input.change:value@dateDiapason', () => {
			this.dom.input.value = this.mediateDisplayValue(this.dom.input.value);
			let realValue = this.calcRealValue(this.dom.input.value);
			this.model.setData(this.startKey, realValue.start, true);
			this.model.setData(this.finishKey, realValue.finish, true);
			this.model.trigger('changed');
			this.validate(true);
		});
		}

	mediateDisplayValue(displayValue)
		{
		return displayValue;
		}

	calcDisplayValue(dbStart, dbFinish)
		{
		// this.calcInputStatus();
		let start = Util.toLocalDate(dbStart);
		let finish = Util.toLocalDate(dbFinish);
		if (this.diapason.start === null)
			{
			return "";
			}
		else if (this.diapason.finish === null)
			{
			return start;
			}
		else
			{
			return start + " - " + finish;
			}
		}

	calcRealValue(displayValue, incorrectValue = undefined)
		{

		if (displayValue === null || displayValue === undefined)
			{
			return incorrectValue;
			}
		let parts = displayValue.split("-");
		return {
			start: Util.toDbDate(parts[0], null),
			finish: Util.toDbDate(parts[1], null)
		};
		}

	validate(silent, error)
		{
		let parts = this.dom.input.value.split("-");
		let start = Util.toDbDate(parts[0], null);
		let finish = Util.toDbDate(parts[1], null);

		if ((start === null || finish === null) && this.dom.input.value.length > 0)
			{
			if (start !== null)
				{
				return super.validate(true, this.errors.incorrectValue, true);
				}
			else
				{
				return super.validate(false, this.errors.incorrectValue, true);
				}
			}


		return super.validate(silent, error);
		}

	};


PF.Field.DateDiapason.Day = class DateDay extends PF.Calendar.Day
	{

	onRender()
		{
		super.onRender();
		this.field = this.list.calendar.field;


		this.onValue('selected', true, () => {
			if (this.get('field.diapason.start', null, null) !== null)
				{
				if (this.model.day.hasSame(this.field.diapason.start, 'day'))
					{
					this.firstSelected = true;

					let bottomDate = this.model.day.plus({days: 7});
					this.bottomSelected = this.field.diapason.start <= bottomDate && bottomDate <= this.field.diapason.finish;
					}
				}
			if (this.get('field.diapason.finish', null, null) !== null)
				{
				if (this.model.day.hasSame(this.field.diapason.finish, 'day'))
					{
					this.lastSelected = true;
					let topDate = this.model.day.minus({days: 7});
					this.topSelected = this.field.diapason.start <= topDate && topDate <= this.field.diapason.finish;
					}
				}
		});
		this.onValue('selected', false, () => {
			this.firstSelected = false;
			this.lastSelected = false;
		});

		if (this.field.diapason.start <= this.model.day && this.model.day <= this.field.diapason.finish)
			{
			this.selected = true;
			this.field.highlightedDays.push(this);
			}

		this.dom.item.on('click', () => {
			console.log('click', Util.toLocalDate(this.model.day));
			this.field.setSelected(this);
		});

		this.bindDom({item: 'class:selected'}, 'selected');
		this.bindDom({item: 'class:first-selected'}, 'firstSelected');
		this.bindDom({item: 'class:last-selected'}, 'lastSelected');
		this.bindDom({item: 'class:top-selected'}, 'topSelected');
		this.bindDom({item: 'class:bottom-selected'}, 'bottomSelected');
		}


	};